export default {
  data () {
    return {
      receipt: {
        receiptNumber: '',
        provider: '',
        providerData: '',
        vatTypeAssigned: {},
        taxBase1: 0,
        vatType1: 21,
        vat1: 0,
        taxBase2: 0,
        vatType2: 10,
        vat2: 0,
        taxBase3: 0,
        vatType3: 4,
        vat3: 0,
        taxBase4: 0,
        vatType4: 0,
        vat4: 0,
        taxBase5: 0,
        vat5: 0,
        vatType5: 0,
        taxBase6: 0,
        vat6: 0,
        vatType6: 0,
        date: null,
        address: '',
        zipCode: '',
        city: '',
        country: '',
        state: ''
      },
      originalReceiptWithoutTaxes: {}
    }
  },
  methods: {
    _generateReceiptVatModel () {
      this.receipt.vat1 = this.taxes.vatType1.vat
      this.receipt.taxBase1 = this.taxes.vatType1.taxBase
      this.receipt.vatType1 =
        this.selectedVatRegion.vatType1 === null
          ? 0
          : this.selectedVatRegion.vatType1

      this.receipt.vat2 = this.taxes.vatType2.vat
      this.receipt.taxBase2 = this.taxes.vatType2.taxBase
      this.receipt.vatType2 =
        this.selectedVatRegion.vatType2 === null
          ? 0
          : this.selectedVatRegion.vatType2

      this.receipt.vat3 = this.taxes.vatType3.vat
      this.receipt.taxBase3 = this.taxes.vatType3.taxBase
      this.receipt.vatType3 =
        this.selectedVatRegion.vatType3 === null
          ? 0
          : this.selectedVatRegion.vatType3
      this.receipt.vat4 = this.taxes.vatType4.vat
      this.receipt.taxBase4 = this.taxes.vatType4.taxBase
      this.receipt.vatType4 =
        this.selectedVatRegion.vatType4 === null
          ? 0
          : this.selectedVatRegion.vatType4
      this.receipt.vat5 = this.taxes.vatType5.vat
      this.receipt.taxBase5 = this.taxes.vatType5.taxBase
      this.receipt.vatType5 =
        this.selectedVatRegion.vatType5 === null
          ? 0
          : this.selectedVatRegion.vatType5
      this.receipt.vat6 = this.taxes.vatType6.vat
      this.receipt.taxBase6 = this.taxes.vatType6.taxBase
      this.receipt.vatType6 =
        this.selectedVatRegion.vatType6 === null
          ? 0
          : this.selectedVatRegion.vatType6

      if (this.selectedVatRegion && this.selectedVatRegion.id) {
        this.receipt.vatTypeAssigned = {
          id: this.selectedVatRegion.id
        }
      }
    }
  }
}
